import {
  CreatableMultiSelect,
  type CreatableMultiSelectProps,
} from "components/ui/CreatableMultiSelect";
import { FieldWrapper } from "components/ui/FieldWrapper";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  useController,
} from "react-hook-form";

export type RhfCreatableMultiSelectProps<T extends FieldValues> = {
  name: FieldPath<T>;
  control?: Control<T>;
  label?: string;
  required?: boolean;
  hint?: string;
} & Omit<CreatableMultiSelectProps, "name" | "value" | "onChange" | "onBlur">;

/**
 * React Hook Form アダプタ for CreatableMultiSelect。
 * @param {RhfCreatableMultiSelectProps<T>} props props
 * @return {JSX.Element} FieldWrapper で包まれた CreatableMultiSelect
 */
export function RhfCreatableMultiSelect<T extends FieldValues>({
  name,
  control,
  label,
  required,
  hint,
  ...rest
}: RhfCreatableMultiSelectProps<T>): JSX.Element {
  const { field, fieldState } = useController<T>({ name, control });

  return (
    <FieldWrapper
      label={label}
      required={required}
      hint={hint}
      error={fieldState.error?.message}
    >
      <CreatableMultiSelect
        {...rest}
        name={field.name}
        value={(field.value as string[]) ?? []}
        onChange={field.onChange}
        onBlur={field.onBlur}
      />
    </FieldWrapper>
  );
}
